import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { MailConfig } from './mailconfig';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');
@Injectable({
  providedIn: 'root'
})
export class MailconfigService {

  constructor(private httpClient: HttpClient) { }
  baseUrl: string = environment.serviceUrl;

  //httpclient get method
  Get(): Observable<MailConfig[]> {
    return this.httpClient.get<MailConfig[]>(this.baseUrl + 'api/MailConfigApi/');
  };

  //httpclient method to get the mail config info for the given id/name
  Getbyinfo(_mailConfigModel: MailConfig): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/MailConfigApi/GetById', _mailConfigModel, { headers: header, observe: 'response' });
  }

  //httpclient post method
  Post(_mailConfigModel: MailConfig): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/MailConfigApi/add', _mailConfigModel,
      { headers: header, observe: 'response' });
  }

  //httpclient put method
  Put(_mailConfigModel: MailConfig): Observable<any> {
    return this.httpClient.put<any>(this.baseUrl + 'api/MailConfigApi/Update', _mailConfigModel,
      { headers: header, observe: 'response' });
  }
  //httpclient delete method
  Delete(_mailConfigModel: MailConfig): Observable<any> {
    return this.httpClient.put<any>(this.baseUrl + 'api/MailConfigApi/activeordeactive', _mailConfigModel, { headers: header, observe: 'response' })
  }
  GetActiveEvents(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + 'api/MailConfigApi/GetActiveEvents');
  };
  GetRequestType(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + 'api/MailConfigApi/GetRequestType');
  };
}
